import type { AttributeConfig, ComponentMode } from 'types';

interface State extends AttributeConfig {
  mode: ComponentMode;
  defaultName: string;
}
const initialState: Partial<State> = {};

type Action =
  | {
      type: 'UPDATE_ATTRIBUTE_TYPE';
      payload: Pick<typeof initialState, 'type'>;
    }
  | {
      type: 'UPDATE_ATTRIBUTE_CATEGORIES';
      payload: Pick<typeof initialState, 'categories'>;
    }
  | undefined;
const initialAction: Action = undefined;

export { initialAction, initialState };
